/*
 * Javascript for address search on membersihp form
 */
var typingTimer;
var doneTypingInterval = 400;
var addresses;
var address_target = "address1";
var findAddress = $(".address_search");
var form = $("form[has-afd-membership]");

(function ($) {
	if (form.length) {
		const todayDate = new Date();

		//Assign email consent date to today
		const fieldIds = [
			"form-input-contact1EmailConsent",
			"form-input-primaryContactEmailConsent",
			"form-input-seniorMinisterEmailConsent",
			"form-input-referee1EmailConsent",
			"form-input-referee2EmailConsent",
			"form-input-churchEmailConsent",
			"form-input-contact1PhoneConsent",
			"form-input-primaryContactPhoneConsent",
			"form-input-seniorMinisterPhoneConsent",
			"form-input-referee1PhoneConsent",
			"form-input-referee2PhoneConsent",
			"form-input-churchPhoneConsent",
			"form-input-contact1MailConsent",
			"form-input-primaryContactMailConsent",
			"form-input-seniorMinisterMailConsent",
			"form-input-referee1MailConsent",
			"form-input-referee2MailConsent",
			"form-input-churchMailConsent",
		];

		fieldIds.forEach((fieldId) => {
			const field = document.getElementById(fieldId);
			if (field) {
				field.value = todayDate.toISOString().slice(0, -8);
			}
		});

		findAddress.each(function () {
			$(this).keyup(function () {
				//set address_target to data-target of the input
				address_target = $(this).data("target");
				console.log("address_target", address_target);

				clearTimeout(typingTimer);
				if ($(this).val()) {
					//If length is more than 3 characters
					if ($(this).val().length > 3) {
						typingTimer = setTimeout(
							() => doneTyping($(this)),
							doneTypingInterval
						);
					}
				}
			});

			$(this).click(function () {
				if ($(this).val()) {
					doneTyping($(this));
				}
			});
		});

		function doneTyping(target) {
			address_search(
				target,
				".address-search-results[data-target=" + address_target + "]",
				"#address_status"
			);
		}

		function address_search(
			input_element,
			address_results,
			status_element,
			page
		) {
			var page = page || 0;
			console.log("address_results", address_results);

			var address = input_element.val().trim();

			if (address != "") {
				// Remove any previous validation results
				if (page == 0) $(address_results).empty();

				// Create a loading message
				var loading_html = $("<div></div>", {
					class: "p-3 text-center",
					id: "address_loading",
					html:
						'<i class="far fa-spinner fa-lg fa-pulse"></i><p class="mt-2 block text-sm">Searching</p>',
				});
				$(address_results).before(loading_html);

				//$(status_element).text("Searching addresses");

				// Country hard coded to GB for this example
				var country_code = "GB";
				// Create the URL to API including API key and encoded search term
				var address_url =
					"/actions/eauk-general/default/get-address?address=" +
					encodeURIComponent(address);

				// Call the API
				$.ajax({
					url: address_url,
				})
					.done(function (data) {
						var results = data.Item;
						addresses = results;

						$("#address_loading").remove();

						if (results) {
							$.each(results, function (index, item) {
								const addressComponents = [item.Organisation, item.Property, item.Street, item.Locality, item.Town, item.PostalCounty, item.Postcode];

								// Filter out undefined and empty values
								const filteredComponents = addressComponents.filter((component) => component);

								// Join the components with ', ' separator
								const addressString = filteredComponents.join(", ");

								// Remove leading commas and multiple consecutive commas
								const optimizedAddressString = addressString.replace(/,+/g, ", ").replace(/^, /, "");

								var address_string = optimizedAddressString;

								address_string = address_string.replaceAll(address, '<span class="font-bold">' + address + "</span>");

								var address_result = '<li data-address="' + index + '" class="cursor-pointer px-5 py-2 rounded-lg hover:bg-gray-50"><h3 class="text-gray-900 font-medium text-md mb-0">' + address_string + "</h3></li>";

								$(address_results).append(address_result);
								$(".address-search-results-container[data-target=" + address_target + "]").removeClass("hidden");
							});
						} else {
							var address_result =
								'<li class="cursor-pointer px-5 py-2 rounded-lg hover:bg-gray-50"><h3 class="text-gray-900 font-medium text-md mb-0 no-address">No address found. Click here to enter your address manually.</h3></li>';

							$(address_results).append(address_result);
							$(
								".address-search-results-container[data-target=" +
									address_target +
									"]"
							).removeClass("hidden");
						}
					})
					.fail(function (error) {
						loading_html.remove();
						$(status_element).text("Error occurred");
						$(address_results).text("Error occurred");
						// Triggered if API does not return HTTP code between 200 and 399
						// More info - https://developers.alliescomputing.com/postcoder-web-api/error-handling
					});
			} else {
				// Could show an "Address search term is required" message here
			}
		}


		$(document).on("click", ".address-search-results li", function (e) {
			e.preventDefault();

			var target = $(this).parent().parent().data("target")
				? $(this).parent().parent().data("target")
				: "address1";

			var addressId = $(this).data("address");

			if ($(this).find(".no-address").length > 0) {
				$(".address-search-results-container").addClass("hidden");
				$("[data-field-container=" + target + "Group]").removeClass(
					"hidden"
				);
				return;
			}

			$("#form-input-" + target + "AddressLatitude").val(
				addresses[addressId].Latitude || ""
			);
			$("#form-input-" + target + "AddressLongitude").val(
				addresses[addressId].Longitude || ""
			);

			$("#form-input-" + target + "AddressArea").val(
				addresses[addressId].EERName || ""
			);

			$("#form-input-" + target + "Name").val(
				addresses[addressId].Organisation || ""
			);
			
			$("#form-input-" + target + "AddressLine1").val(
				addresses[addressId].Property || ""
			);

			$("#form-input-" + target + "AddressLine2").val(
				addresses[addressId].Street || ""
			);

			$("#form-input-" + target + "AddressLine3").val(
				addresses[addressId].Locality || ""
			);

			$("#form-input-" + target + "AddressCity1").val(
				addresses[addressId].Town || ""
			);

			$("#form-input-" + target + "AddressCounty").val(
				addresses[addressId].PostalCounty || ""
			);

			$("#form-input-" + target + "AddressPostcode").val(
				addresses[addressId].Postcode || ""
			);

			$(".address-search-results-container").addClass("hidden");
			$("[data-field-container=" + target + "Group]").removeClass(
				"hidden"
			);
		});

		var accountNumber = "";
		var branchSortCode = "";

		$("#check-bank-details").click(function () {

			accountNumber = $("#form-input-acciuntNumber").val();
			branchSortCode = $("#form-input-branchSortCode").val();

			if (accountNumber && branchSortCode) {
				console.log("check 2");
				$(".bank-results").removeClass("hidden");

				$.get("https://pce.afd.co.uk/afddata.pce", {
					data: "bank",
					serial: "831775",
					password: "ucEo0dG8",
					task: "account",
					clearing: "all",
					fields: "account",
					sortcode: branchSortCode,
					accountnumber: accountNumber,
					format: "json",
				})
					.done(function (response) {
						if (response.Result === "1") {
							$(".bank-results")
								.removeClass("border-red-500")
								.addClass("border-green-500")
								.html(
									"Success: The account number and sort code are valid."
								);
						} else {
							$(".bank-results")
								.removeClass("border-green-500")
								.addClass("border-red-500")
								.html("Failure: " + response.ErrorText);
						}
					})
					.fail(function () {
						$(".bank-results").html(
							"Failure: The request could not be completed."
						);
					});
			}
		});
	}
})(jQuery);
